module.exports = __webpack_public_path__ + "img/f67.f80f370f.png";